/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResourceStateEnum {
    Active = 'ACTIVE',
    Expiring = 'EXPIRING',
    Expired = 'EXPIRED'
}

export function ResourceStateEnumFromJSON(json: any): ResourceStateEnum {
    return ResourceStateEnumFromJSONTyped(json, false);
}

export function ResourceStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceStateEnum {
    return json as ResourceStateEnum;
}

export function ResourceStateEnumToJSON(value?: ResourceStateEnum | null): any {
    return value as any;
}

